import { WizardState, WizardCurrentProcessState, WizardStatesValues } from './types';

const defaultCurrentProcessState: WizardCurrentProcessState = {
  isLoading: false,
  errors: [],
  currentStepConfig: null,
  processId: null,
  stepId: undefined,
};

const defaultWizardStatesValues: WizardStatesValues = {
  preloadedData: null,
  formData: null,
  shouldNavigateTo: null,
  currentProcessState: defaultCurrentProcessState,
  shouldPerformAction: null,
};

const defaultWizardProviderValues: WizardState = {
  preloadedData: null,
  networkCallErrors: null,
  setNetworkCallErrors: undefined,
  currentProcessState: defaultCurrentProcessState,
  goToNextWizardStep: (formData: any) => {
    console.log('goToNextWizardStep', formData);
  },
  goToPreviousWizardStep: () => {
    console.log('goToPreviousWizardStep');
  },
  actionWizardStep: (actionType: string) => {
    console.log('actionWizardStep', actionType);
  },
  currentStepConfig: { Component: null, parameters: {}, layout: {} },
};

export { defaultWizardProviderValues, defaultWizardStatesValues };
